
import { mapState } from 'vuex';
import { Collapse, CollapseItem } from 'element-ui';

export default {
  name: 'CheckoutPaymentMethods',
  components: { Collapse, CollapseItem },
  data() {
    return { activeNames: null };
  },
  computed: {
    ...mapState('checkout', ['paymentMethods']),
    sortedPaymentMethods() {
      return [...(this.paymentMethods || [])].sort(
        (a, b) => (a?.Position || 0) - (b?.Position || 0)
      );
    },
    almaPaymentMethods() {
      return this.sortedPaymentMethods.filter(
        (method) => method.PaymentProvider === 'Alma'
      );
    },
    groupedPaymentMethods() {
      const groups = [];
      let almaAdded = false;

      this.sortedPaymentMethods.forEach((method) => {
        if (method.PaymentProvider === 'Alma') {
          if (almaAdded) return;

          almaAdded = true;
          const firstAlma = this.almaPaymentMethods[0] || method;
          groups.push({
            ...firstAlma,
            PaymentName: 'Alma',
            PaymentTitle:
              firstAlma.PaymentTitle || this.$t('Payment in installments with Alma'),
            PaymentDescription:
              firstAlma.PaymentDescription ||
              this.$t('Payment in 2, 3 or 4 installments without fees.'),
            isAlmaGroup: true,
            collapseName: 'ALMA_GROUP',
          });
          return;
        }

        groups.push({
          ...method,
          isAlmaGroup: false,
          collapseName: method.IdPayment,
        });
      });

      return groups;
    },
    // Refactored Alma methods to computed properties for cleaner template
    alma1x() {
      return this.getAlmaMethod(1);
    },
    alma2x() {
      return this.getAlmaMethod(2);
    },
    alma3x() {
      return this.getAlmaMethod(3);
    },
    alma4x() {
      return this.getAlmaMethod(4);
    },
  },
  methods: {
    getAlmaMethod(count) {
      const code = `ALMA${count}X`;
      const method = this.paymentMethods?.find((m) => m.PaymentCode === code);
      return method ? method.PaymentCode : null;
    },
    handleChange(val) {
      // Handle collapse change if needed, currently empty
    },
  },
  watch: {
    groupedPaymentMethods: {
      handler(val) {
        if (!val?.length) {
          this.activeNames = null;
          return;
        }

        const hasCurrent = val.some(
          (method) => method.collapseName === this.activeNames
        );
        if (!hasCurrent) {
          this.activeNames = val[0].collapseName;
        }
      },
      immediate: true,
    },
  },
};
